import { trackPromise } from 'react-promise-tracker';

export async function getCampaigns(Estado, userToken) {

    return trackPromise(fetch('https://t41bx8uqf6.execute-api.us-east-2.amazonaws.com/prod/votacion/campana', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'authorizationToken': userToken
        },
        body: JSON.stringify({"Estado":Estado})
    }).then(data => data.json()))
}